import React, {Fragment, Component} from 'react';
import * as authService from '../../services/auth';
import {Redirect} from 'react-router-dom';
import qs from 'qs';
import {user} from '../../modules/constants';
import {
  youtubeGetInfoByPlaylist, youtubeGetPlaylistsByChannel,
  youtubeGetChannelSummary,
} from '../../services/apiRequests';

class LoginPage extends Component {
  state = {
    login: '',
    password: '',
  };

  handleSubmitLogin = (e) => {
    e.preventDefault();
  };

  handleInputChange = (e) => {
    let {value, name} = e.target;

    this.setState({
      [name]: value,
      showError: false,
    });
  };

  componentDidMount() {
    const query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })

    switch (query.type) {
      case 'playlistItems':
        youtubeGetInfoByPlaylist(query.id);
        break;
      case 'playlists':
        youtubeGetPlaylistsByChannel(query.id);
        break;
      case 'channelSummary':
        youtubeGetChannelSummary(query.id);
        break;
    }
  }

  render() {
    let {from} = this.props.location.state || {from: {pathname: '/'}};
    let {redirectToReferrer} = this.state;
    if (redirectToReferrer) {
      return <Redirect to={from}/>;
    }

    return (
        <Fragment>
          <h1 className="login-header">You need to login before viewing this page.</h1>

          <form className="login-form" onSubmit={() => {
          }}>
            <input
                type="text"
                className="input-login"
                placeholder="Username or Email"
                name='login'
                value={this.state.login}
                onChange={this.handleInputChange}
            />
            <input
                type="password"
                className="input-password"
                name='password'
                placeholder="Password"
                value={this.state.password}
                onChange={this.handleInputChange}
            />

            <button
                className="login-btn btn-large waves-effect waves-light blue lighten-1"
                onClick={() => {
                }}
            >Login
            </button>

          </form>
        </Fragment>
    );
  }
}

export default LoginPage;


// WEBPACK FOOTER //
// ./src/containers/pages/LoginPage.js